import { render } from "./ReportChart.vue?vue&type=template&id=3ecb1d71"
import script from "./ReportChart.vue?vue&type=script&lang=js"
export * from "./ReportChart.vue?vue&type=script&lang=js"

import "./ReportChart.vue?vue&type=style&index=0&id=3ecb1d71&lang=css"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__